import {getProviderStatusQuery} from './get-provider-status.query'

export const ProviderStatusQueries = {
  getProviderStatusQuery,
}
